import { useState } from "react";
import AllProducts from "./products";
import BestDeal from "./best-deals";
import { FiSearch, FiBox, FiStar } from "react-icons/fi";

const BestDeals = () => {
    const [activeLink, setActiveLink] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");

    const menuItems = [
        { key: "all", label: "Products", icon: <FiBox /> },
        { key: "best-deals", label: "Best Deals", icon: <FiStar /> },
    ];

    return (
        <div className="w-full px-4 md:px-8">
            <div className="flex flex-col md:flex-row gap-8">
                <div className="w-full md:w-64 bg-white flex flex-col items-end  rounded-xl p-4">
                    <nav className="flex flex-col space-y-2">
                        {menuItems.map((item) => (
                            <div
                                key={item.key}
                                onClick={() => setActiveLink(item.key)}
                                className={`flex items-center px-4 py-3 rounded-lg cursor-pointer transition-all ${
                                    activeLink === item.key
                                        ? "bg-yellow-50 border-l-4 border-yellow-500 text-yellow-700 font-medium"
                                        : "text-gray-600 hover:bg-gray-50"
                                }`}
                            >
                                <span className="text-lg mr-3">{item.icon}</span>
                                <span>{item.label}</span>
                            </div>
                        ))}
                    </nav>
                </div>

                <div className="flex-1">
                    {activeLink === "all" && (
                        <div className="mt-5 mb-2">
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <FiSearch className="text-gray-400 text-lg" />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Search products..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="w-full pl-12 pr-6 py-2 border-0 border-b-2 border-gray-200 focus:border-b-2 focus:border-yellow-500 outline-none transition-all placeholder:text-gray-400 placeholder:text-sm"
                                />
                            </div>
                        </div>
                    )}
                    <div className="mt-4">
                        {activeLink === "all" ? (
                            <AllProducts searchQuery={searchQuery} />
                        ) : (
                            <BestDeal />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BestDeals;